<template>
    <i :class='social'></i>
    <!--<img :src="`${templateDir}/assets/images/${social}-white.svg`" :alt="altText" >-->
</template>

<script>
    export default {
        name: "ShareButtons",
        props: ['social', 'altText'],
        data: () => ({
        }),
        computed: {
            templateDir: {
                get: function () {
                    return window.social_share_post_data.template_dir
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SocialIcon.vue